import React from 'react';
import './logo.scss';

export default () => (
  <div className="wrapper">
    <p>Powered by Vizion</p>
  </div>
);
